<!-- FORM-FIELD

EXEMPLO SHOWDUPLICADOS:

    <form-field v-model="regraimp.cfop" type="typeahead" col="6"
        :metadata="metadata.regraimp.cfop" entity="cfop/saidas"></form-field>
        :show-duplicados="{ url: '/crm/pessoas/duplicados?nome=' }"

EXEMPLO SELECT2:

        <form-field v-model="regraimp.cfop" type="select2" col="6"
            :metadata="metadata.regraimp.cfop"
            :select2="{entity: 'cfop/saidas', minlength: 0}"></form-field>

EXEMPLO TYPEAHEAD:

        <form-field v-model="regraimp.cfop" type="typeahead" col="6"
            :metadata="metadata.regraimp.cfop" entity="cfop/saidas"></form-field>

EXEMPLO COM BOTAO ADICIONAR:

        <form-field v-model="pedv.codpart" type="select2" col="6" :metadata="metadata.pedv.codpart" :disabled="isView"
            name="codpart" :v-errors="errors" v-validate="metadata.pedv.codpart.validator"
            :add-button="true" @clickAdd="handleIncluirCliente()"></form-field>


EXEMPLOS DATE:

        <form-field v-model="regraimp.dtinicio" type="date" col="col-md-2 col-6"
            :metadata="metadata.regraimp.dtinicio"></form-field>

EXEMPLO SELECT:

        <form-field v-model="pedv.codtabpre" type="select" col="6" :metadata="metadata.pedv.codtabpre"
            :select-options="tabelas_preco_options"
            name="codtabpre" :v-errors="errors" v-validate="{required: true}"></form-field>

CASE:
  case="lower"
  case="upper" (default)
  case="normal"

-->

<template>
  <div :class="_col">

    <div class="form-group form-group-sm">
      <div v-if="((label || metadata) && (nolabel != true))">
        <v-label v-if="!addButton" :label="label" :metadata-field="metadata"></v-label>
        <v-label v-if="addButton" :label="label" :metadata-field="metadata" title-add-button="Cadastrar"
          @clickAdd="handleAddButton()"></v-label>
      </div>

      <div class="input-group input-group-sm" v-bind:class="classObject">
        <div v-if="preaddon" class="input-group-prepend">
          <span class="input-group-text">{{ preaddon }}</span>
        </div>

        <!-- text -->
        <input ref="input" type="text" class="form-control form-control-sm" autocomplete="off" :style="_case"
          @keydown.enter="focusControl($event)" :disabled="disabled" :tabindex="tabindex" :value="value"
          @input="input($event.target.value)" @keydown="keymonitor" :placeholder="placeholder" :maxlength="maxlength"
          v-if="type == 'text'">

        <!-- cardnumber -->
        <input ref="input" type="text" class="form-control form-control-sm" autocomplete="off"
          v-mask="generateCardNumberMask" @keydown.enter="focusControl($event)" :disabled="disabled" :tabindex="tabindex"
          :value="value" @input="input($event.target.value)" :placeholder="placeholder" v-if="type == 'cardnumber'">

        <select ref="input" class="form-control form-control-sm" @keydown.enter="selectfocusControl($event)"
          @keyenter="handleEnter" :tabindex="tabindex" :disabled="disabled" :value="value" @change="select"
          v-if="type == 'month'">
          <option value="" disabled selected>Mês</option>
          <option v-for="n in 12" :key="n" :value="n < 10 ? '0' + n : n" :disabled="n < minCardMonth"
            v-text="n < 10 ? '0' + n : n">
          </option>
        </select>

        <select ref="input" class="form-control form-control-sm" @keydown.enter="selectfocusControl($event)"
          @keyenter="handleEnter" :tabindex="tabindex" :disabled="disabled" :value="value" @change="select"
          v-if="type == 'year'">
          <option value="" disabled selected>Ano</option>
          <option v-for="(n, $index) in 12" :key="n" :value="$index + minCardYear" v-text="$index + minCardYear">
          </option>
        </select>

        <!-- password -->
        <div class="input-group" v-if="type == 'password'">
          <input type='password' name='none' hidden v-if="hiddeLoginInformations" />
          <input ref="input" :type="passwordFieldType" class="form-control form-control-sm"
            @keydown.enter="focusControl($event)" :disabled="disabled" :value="value" @input="input($event.target.value)"
            autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly')">
          <div v-if="type == 'password'" class="input-group-append">
            <span class="input-group-text" @click="handlePassword" title="Exibir a senha" style="cursor: pointer"><i
                class="fa fa-eye"></i></span>
          </div>
        </div>
        <!-- memo -->
        <textarea ref="input" rows="4" class="form-control form-control-sm" :disabled="disabled" :value="value"
          @input="input($event.target.value)" v-if="type == 'memo'"></textarea>

        <!-- valor -->
        <input-value ref="input" class="form-control form-control-sm" @keyenter="handleEnter" :precision="_precision"
          :tabindex="tabindex" :disabled="disabled" :value="value" @input="input" v-if="type == 'value'">
        </input-value>

        <!-- numero -->
        <input-number ref="input" class="form-control form-control-sm" @keyenter="handleEnter" @focus="handleFocus"
          @blur="handleBlur" :disabled="disabled" :tabindex="tabindex" :value="value" @input="input"
          :maxlength="maxlength" v-if="type == 'number'">
        </input-number>

        <!-- cnpj -->
        <input ref="input" type="text" class="form-control form-control-sm" autocomplete="off" :style="_case"
          @keydown.enter="focusControl($event)" :disabled="disabled" :tabindex="tabindex" :value="value"
          @input="input($event.target.value)" @keydown="keymonitor" :placeholder="placeholder" :maxlength="18"
          v-if="type == 'cnpj'">

        <!-- cpf -->
        <input-number ref="input" class="form-control form-control-sm" @keyenter="handleEnter" :disabled="disabled"
          :tabindex="tabindex" :value="value" @input="input" v-if="type == 'cpf'">
        </input-number>

        <!-- data -->
        <input-date ref="input" class="form-control form-control-sm" @keyenter="handleEnter" :disabled="disabled"
          :tabindex="tabindex" :value="value" @input="input" v-if="type == 'date'">
        </input-date>

        <!-- hora -->
        <input-hora ref="input" class="form-control form-control-sm" @keyenter="handleEnter" :disabled="disabled"
          :tabindex="tabindex" :value="value" @input="input" v-if="type == 'hora'">
        </input-hora>

        <!-- select combobox -->
        <select ref="input" class="form-control form-control-sm" @keydown.enter="selectfocusControl($event)"
          @keyenter="handleEnter" :tabindex="tabindex" :disabled="disabled" :value="value" @change="select"
          v-if="type == 'select'">
          <option value="" v-if="optionnull !== true"> {{ placeholder }} </option>
          <option v-for="opt in _selectOptions" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
        </select>

        <!-- pesquisa -->
        <select2 v-if="type == 'select2' && _select2" :value="value" @input="input" :entity="_select2.entity"
          :parent="parent" @keyenter="handleEnter" :placeholder="placeholder" :tabindex="tabindex" :disabled="disabled"
          :minlength="_select2.minlength">
        </select2>

        <!-- pesquisa select2 com opcoes de array -->
        <select2static v-if="type == 'select2static'" :parent="parent" @keyenter="handleEnter" :placeholder="placeholder"
          :value="value" @input="input" :options="_selectOptions" :multiple="selectMultiple" :minlength="0"
          :tabindex="tabindex" :disabled="disabled">
        </select2static>

        <!-- cep -->
        <input-cep ref="input" class="form-control form-control-sm" @update="updateCep" @keyenter="handleEnter"
          :tabindex="tabindex" maxlength="8" :disabled="disabled" :value="value" @input="input"
          v-if="type == 'cep'"></input-cep>

        <!-- telefone -->
        <input-fone ref="input" class="form-control form-control-sm" @focus="handleFocus" @blur="handleBlur"
          @keyupesc="handleEsc()" @keyupenter="handleEnter()" @keydowntab="handleKeyTab()" @keyupdown="handleKeyDown()"
          @keyupup="handleKeyUp()" @update="updateFone" @keyenter="handleEnter" :tabindex="tabindex" :disabled="disabled"
          :value="value" @input="input" v-if="type == 'fone'"></input-fone>

        <!-- email -->
        <input-email ref="input" class="form-control form-control-sm" :name="name" @update="updateEmail"
          @keyenter="handleEnter" :tabindex="tabindex" maxlength="255" :disabled="disabled" :value="value" @input="input"
          v-if="type == 'email'"></input-email>

        <!-- color -->
        <input-color-picker ref="input" @keyenter="handleEnter" :tabindex="tabindex" :disabled="disabled" :value="value"
          @input="input" v-if="type == 'color'">
        </input-color-picker>


        <div v-if="addon" class="input-group-append">
          <span class="input-group-text">{{ addon }}</span>
        </div>

        <div v-if="showSearching" class="spinner-border ml-auto" role="status" aria-hidden="true"></div>

      </div>

      <!-- <small class="error" v-if="metadata && vErrors && vErrors.has(metadata.fieldname)">{{ vErrors.first(metadata.fieldname) }}</small> -->
      <small class="error" v-if="name && vErrors && vErrors.has(name)">{{ vErrors.first(name) }}</small>

      <!-- LISTA DE DUPLICADOS -->
      <div v-if="listDuplicados.length > 0" class="dropdown-total col-md-4 col-10">
        <div class="row mb-2" style="border-bottom: 1px solid gray">
          <button type="button" class="close" @click="showTotal = false"><span aria-hidden="true">&times;</span></button>
        </div>
        <div v-for="(item, index) in listDuplicados" :key="index">
          <div class="row">
            <div class="col-md-12 col-12"> {{ item.text }}
              <div class="float-right">
                <a style="cursor: pointer; color: #0091ea;"><i class="fa fa-paperclip"></i></a>
              </div>
            </div>
            <div class="col-md-12 col-12" v-if="item.text2"> {{ item.text2 }} </div>
            <div class="col-md-12 col-12" v-if="item.text3"> {{ item.text3 }} </div>
          </div>
        </div>
      </div>
      <!-- FIM LISTA DE DUPLICADOS -->

      <slot></slot>
    </div>
  </div>
</template>

<script>
import { SysVars } from '../main'
import { hasHiddenParent, stringToInteger } from '../shared/utils';
import { apiORDS } from '../shared/api-functions'

export default {
  name: 'form-field',

  props: {
    metadata: { type: Object },
    precision: { type: Number },
    addButton: { type: Boolean },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    label: { type: String },
    col: { type: String },
    selectOptions: { type: Array },
    selectMultiple: { type: Boolean },
    select2: { type: Object },
    value: {},
    vErrors: {},
    name: { type: String },
    tabindex: { type: Number },
    parent: { type: String },
    case: { type: String },
    addon: { type: String },
    preaddon: { type: String },
    nolabel: { type: Boolean },
    placeholder: { type: String },
    optionnull: { type: Boolean },
    showDuplicados: { type: Object },
    maxlength: { type: String },
    cardMonth: { type: String },
    cardYear: { type: String },
    validateDisabledKeys: { type: Boolean, default: true },
    hiddeLoginInformations: { type: Boolean, default: false }
  },

  data() {
    return {
      passwordFieldType: 'password',
      listDuplicados: [],
      showSearching: false,
      iconDuplicado: false,
      cardNumber: "",
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      disabledKeys: "\\",
    }
  },

  methods: {
    keymonitor(event) {
      if (this.validateDisabledKeys)
        if (this.disabledKeys.indexOf(event.key) >= 0)
          event.preventDefault()
    },

    handleKeyTab() {
      this.$emit('keydowntab')
    },

    handleBlur() {
      this.$emit('blur')
    },

    handleFocus() {
      this.$emit('focus')
    },

    handleEsc() {
      this.$emit('keyupesc')
    },

    handleEnter(e) {
      this.$emit('keyupenter')
      this.$emit('keyenter')
    },

    handleKeyDown() {
      this.$emit('keyupdown')
    },

    handleKeyUp() {
      this.$emit('keyupup')
    },

    focusControl: function (event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
      var next = thisIndex + 1
      var obj = jQuery(SysVars.sFocusControl)
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
          jQuery(obj[x]).focus()
          return
        }
      }
      for (var x = 0; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
          jQuery(obj[x]).focus()
          return
        }
      }
    },

    selectfocusControl: function (event) {
      event.preventDefault();
      var thisIndex = jQuery(this.$el.querySelector('select')).index(SysVars.sFocusControl)
      var next = thisIndex + 1
      var obj = jQuery(SysVars.sFocusControl)
      for (var x = next; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
          jQuery(obj[x]).focus()
          return
        }
      }
      for (var x = 0; x < obj.length; x++) {
        if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
          jQuery(obj[x]).focus()
          return
        }
      }
    },


    input: function (value) {
      let val = value
      if (this.type == 'cnpj') {
        val = value.toUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 14);
      } else if (this.type == 'text') {
        if (!this.case || this.case === 'upper') {
          val = value.toUpperCase()
        } else if (!this.case || this.case === 'lower') {
          val = value.toLowerCase()
        } else {
          val = value
        }
      }
      this.$emit('input', val)
    },

    focus: function () {
      if (this.$refs.input) {
        let self = this
        this.$nextTick(function () {
          //const rect = this.$refs.pesquisa.getBoundingClientRect();
          self.$refs.input.focus()
        })
      }
    },

    updateCep: function () {
      this.$emit('update')
    },

    updateFone: function () {
      this.$emit('update')
    },

    updateEmail: function () {
      this.$emit('update')
    },

    select(evt) {
      this.$emit('input', evt.target.value);
    },

    handlePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },

    handleAddButton() {
      this.$emit('clickAdd')
    },

    handleChange() {
      if (this.showDuplicados)
        this.timerDuplicados()
    },

    /////////////////// PESQUISA DUPLICADOS
    timerDuplicados() {

      if (this.keytimer) {
        clearTimeout(this.keytimer);
      }

      let vm = this
      this.keytimer = setTimeout(function () {
        vm.pesquisaDuplicados()
      }, 300);

    },

    async pesquisaDuplicados() {
      if (!this.showDuplicados.url)
        return

      this.listDuplicados = []

      this.showSearching = true
      this.iconDuplicado = false
      const data = await apiORDS(this.$store, this.showDuplicados.url + this.value)
      this.searching = false
      if (data.items && data.items.length > 0) {
        this.iconDuplicado = true
        this.listDuplicados = data.items
      }
    }
  },


  computed: {
    _case: function () {
      if (!this.case || this.case === 'upper') {
        return 'text-transform:uppercase'
      } else if (!this.case || this.case === 'lower') {
        return 'text-transform:lowercase'
      } else {
        return ''
      }
    },

    _entity: function () {
      if (this.entity) {
        return this.entity
      } else {
        if (this.metadata && this.metadata.select2) {
          return this.metadata.select2.entity
        } else {
          return null
        }
      }
    },
    _select2: function () {
      if (this.select2) {
        return this.select2
      } else {
        if (this.metadata && this.metadata.select2) {
          return this.metadata.select2
        } else {
          return null
        }
      }
    },
    _precision: function () {

      if (this.precision && stringToInteger(this.precision)>0) {
        return stringToInteger(this.precision)
      } else {
        if (this.metadata && this.metadata.decimals) {
          return stringToInteger(this.metadata.decimals)
        } else {
          return stringToInteger(this.precision)
        }
      }

    },
    _selectOptions: function () {
      if (this.selectOptions) {
        return this.selectOptions
      } else if (this.metadata && this.metadata.options) {
        return this.metadata.options
      }
    },
    _col: function () {
      if (!this.col) {
        return ''
      }
      let col = String(this.col)
      let colxs = 6
      if (this.col == 1) {
        colxs = 4
      }
      if (this.col >= 2) {
        colxs = 6
      }
      if (this.col >= 4) {
        colxs = 12
      }
      col = col.replace(col, 'col-md-' + col + ' col-' + colxs)
      return col
    },
    classObject: function () {
      return {
        obrigatorio: (this.metadata && this.metadata.validator && (this.metadata.validator.required == true) && ((!this.value) || (this.value == ''))),
      }
    },

    // Informações do Cartão
    getCardType() {
      let number = this.cardNumber;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return "visa"; // default type
    },
    generateCardNumberMask() {
      return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth() {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },

    mandatory(name) {
      return name && vErrors && vErrors.has(name)
    }
  },

  watch: {
    vErrors: {
      handler() {
        this.changed = true
      },
      deep: true
    },
    cardYear() {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = "";
      }
    }
  },

  created() {


  },

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/form-field.vue